// Navdata.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../admin/components/util/AuthService";
import { menuItems } from "./navItems"; // Import menuItems

const Navdata = () => {
    const history = useNavigate();

    const userData = AuthService.getUserData();
    const userType = userData ? userData.users_type_id : null;

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    // Create state variables for each menu item using the imported array
    const [menuState, setMenuState] = useState(() => {
        const state = {};
        menuItems.forEach(item => {
            if (item.id) {
                state[item.id] = item.stateVariables;
            }
        });
        return state;
    });

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        setMenuState(prevState => {
            const newState = { ...prevState };
            Object.keys(newState).forEach(key => {
                if (key !== iscurrentState) {
                    newState[key] = false;
                }
            });
            return newState;
        });
    }, [history, iscurrentState]);

    const handleMenuClick = (e, id, hasSubItems) => {
        e.preventDefault();

        // Se for um submenu, expande/colapsa sem alterar o estado principal
        setMenuState(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));

        // Apenas altera o estado global se não for um submenu
        if (!hasSubItems) {
            setIscurrentState(id);
        }

        updateIconSidebar(e);
    };

    const updatedMenuItems = menuItems.map(item => {
        if (item.id) {
            return {
                ...item,
                stateVariables: menuState[item.id],
                click: (e) => handleMenuClick(e, item.id)
            };
        }
        return item;
    });

    return <React.Fragment>{updatedMenuItems}</React.Fragment>;
};

export default Navdata;